
export default {
  name: 'rotate-handler',
}
